import { render, staticRenderFns } from "./OrderCart.vue?vue&type=template&id=3affa05e&"
import script from "./OrderCart.vue?vue&type=script&lang=js&"
export * from "./OrderCart.vue?vue&type=script&lang=js&"
import style0 from "./OrderCart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports